import React from "react";
import { Routes, Route } from "react-router-dom";
import MasterTemplate from "../user-panel/pages/MasterTemplate";
import TakeTraining from "../user-panel/pages/taketraining/TakeTraining";
import DownloadGuide from "../user-panel/pages/downloadguide/DownloadGuide";
import PracticeTests from "../user-panel/pages/practicstests/PracticeTests";
import LiveTrainings from "../user-panel/pages/livetraining/LiveTrainings";
import ExamHistory from "../user-panel/pages/examhistory/ExamHistory";
import Certification from "../user-panel/pages/certification/Certification";
import Account from "../user-panel/pages/account/Account";
import MyExams from "../user-panel/pages/dashboard/MyExams";
import ExploreOurCertification from "../user-panel/pages/certification/ExploreOurCertification";
import Invoice from "@/pages/Invoice";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
import SetPassword from "@/pages/SetPassword";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PrivacyPolicy from "@/components/sections/PrivacyPolicy";
import Landing from "@/pages/Landing";
import CandidateDashboard from "@/user-panel/pages/dashboard/CandidateDashboard";
import SignedOut from "@/pages/SignedOut";
import VerifyCertificate from "@/pages/VerifyCertificate";

function CandidateRoutes() {
  return (
    <Routes>
      {/* ---------- Public routes (MasterTemplate layout ke bahar) ---------- */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/sign-up" element={<SignUp />} />
         <Route path="invoice" element={<Invoice />} />
      <Route path="/confirm" element={<SetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/signed-out" element={<SignedOut />} />
      <Route path="/verify-certificate" element={<VerifyCertificate />} />
      <Route path="/verify-certificate/:certificateId" element={<VerifyCertificate />} />

      {/* ---------- Protected / dashboard layout ---------- */}
      <Route path="/user-panel" element={<MasterTemplate />}>
        {/* index route -> login ke baad default page */}
        <Route index element={<MyExams />} />
        <Route path="dashboard/:code" element={<CandidateDashboard />} />
        <Route
          path="explore-certifications"
          element={<ExploreOurCertification />}
        />
        <Route path="training" element={<TakeTraining />} />
        <Route path="guide" element={<DownloadGuide />} />
        <Route path="practice-tests" element={<PracticeTests />} />
        <Route path="live-trainings" element={<LiveTrainings />} />
        <Route path="exam-history" element={<ExamHistory />} />
        <Route path="certification" element={<Certification />} />
        <Route path="account" element={<Account />} />
      </Route>
    </Routes>
  );
}

export default CandidateRoutes;